import * as React from 'react'
import { useEffect, useState } from 'react'
import Flex from 'typescript-styled-flex'
import { FiEdit2, FiPlus, FiSave, FiTrash } from 'react-icons/fi'
import { Trans, useTranslation } from 'react-i18next'
import { formValues, reduxForm, submit } from 'redux-form'
import { useDispatch, useSelector } from 'react-redux'
import { Divider, IconButton } from '@material-ui/core'
import { Desktop, is, Mobile } from '../../components/MediaQuery'
import { ButtonsWrapper, SubmitButton } from '../../components/Form'
import useSize from '../../hooks/useSize'
import { NumberInput, Select } from '../../components/FormBuilder'
import { PriceSectionLabel } from '../Form/PriceConfiguration/PriceStyle'
import AddButton from '../../components/AddButton'
import { getPrepaymentType } from '../../reducers/userObject/selectors/object'
import Button from '../../components/Template/Button'
import UpdateModal from '../Services/UpdateModal'
import { Modals } from '../Modals/ModalContainer'
import openModal from '../../actions/Modals/openModal'
import { PaymentDictionaryActions } from '../../reducers/paymentDictionary/actionNames'
import { sortPrepayment } from '../../screens/PricePrepayment/PricePrepayment'

function Prepayment({ userProvision, ...rest }) {
  const { t } = useTranslation()
  const size = useSize('profile')
  const isDesktop = is.desktop()

  const userPrepayment = userProvision
  const [prepayment, setPrepayment] = useState<any>([])

  const type = useSelector(getPrepaymentType)

  useEffect(() => {
    setPrepayment(userPrepayment)
    rest.initialize({
      prepayment_type: type,
      provision: sortPrepayment(userPrepayment),
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userPrepayment])

  const dispatch = useDispatch()

  const submitForm = () => {
    dispatch(submit('prepayment'))
  }

  const addPrepayment = (percent, days) => () => {
    if (prepayment && prepayment.length !== 0) {
      setPrepayment([...prepayment, { days: days, percent: percent } as any])
    } else {
      setPrepayment([{ days: days, percent: percent }])
    }

    rest.array.push('provision', { days: days, percent: percent })
    rest.change('percent', '')
    rest.change('days', '')
  }

  const removePrepayment = index => () => {
    setPrepayment(prepayment.filter((s, i) => index !== i))
    rest.array.remove('provision', index)
  }

  const edit = (index, percent, days) => () => {
    rest.change(`provision[${index}]`, { days, percent })
    setPrepayment(
      prepayment.map((p, i) => (i === index ? { days, percent } : p)),
    )
  }

  const editPrepayment = index => () => {
    dispatch(
      openModal(
        Modals.UpdatePrepayment,
        <UpdateModal
          prepayment={prepayment[index]}
          index={index}
          edit={edit}
        />,
      ),
    )
  }

  return (
    <Flex column={true} style={{ padding: '1.2em', width: '100%' }}>
      <Desktop>
        <ButtonsWrapper isDesktop={isDesktop}>
          <SubmitButton size={size} type="button" onClick={submitForm}>
            <FiSave />
            <Trans i18nKey={'save'} />
          </SubmitButton>
        </ButtonsWrapper>
      </Desktop>

      <PriceSectionLabel
        style={{ color: '#696a6d', fontSize: `${16 * size}px` }}
      >
        {t(`pre_payment_form`)}
      </PriceSectionLabel>

      <Divider
        style={{ margin: '15px 0px', marginTop: '10px', width: '100%' }}
      />

      <Select.ReduxField
        size={size}
        isHorizontal={isDesktop}
        name={'prepayment_type'}
        wrapperStyle={{ width: isDesktop ? '50%' : '100%' }}
        label={t('BED_5127_default_prepayment')}
        width={isDesktop ? '70%' : '100%'}
        className={'price-prepayment-form-prepayment-type-select'}
      >
        <Select.Option
          data-cy={'price-prepayment-form-prepayment-type-0-select-option'}
          value={'0'}
        >
          <Trans i18nKey={'pre_payment_form_down'} />
        </Select.Option>
        <Select.Option
          data-cy={'price-prepayment-form-prepayment-type-1-select-option'}
          value={'1'}
        >
          <Trans i18nKey={'reservation_advance_payment'} />
        </Select.Option>
      </Select.ReduxField>

      {!isDesktop && (
        <Divider
          style={{ margin: '15px 0px', marginBottom: '0px', width: '100%' }}
        />
      )}

      <Flex
        row={isDesktop}
        column={!isDesktop}
        style={{
          alignItems: 'flex-start',
          fontSize: `${13 * size}px`,
          margin: `${15 * size}px 0px ${10 * size}px 0px`,
          width: isDesktop ? '50%' : '100%',
        }}
      >
        <span
          style={{
            color: '#696a6d',
            fontSize: isDesktop ? `${14 * size}px` : `${13 * size}px`,
            fontWeight: 500,
            minWidth: '50%',
            width: '100%',
          }}
        >
          {t('configuration')}
        </span>
        <Flex column={true} style={{ width: '100%' }}>
          <Flex row={isDesktop} column={!isDesktop} alignEnd={isDesktop}>
            <NumberInput.ReduxField
              name={'percent'}
              size={size}
              className={'price-prepayment-form-percentmax_amount'}
              withoutPicker={true}
              minValueForNumber={0}
              onlyInteger={true}
              maxValueForNumber={100}
              inputStyle={{
                paddingRight: '25px',
                textAlign: 'right',
              }}
              withAfterIcon={
                <div style={{ fontSize: '14px', opacity: '0.6' }}>%</div>
              }
              label={t('BBO_1494_percent')}
            />
            <NumberInput.ReduxField
              wrapperStyle={{
                marginLeft: isDesktop ? '20px' : '0px',
              }}
              className={'price-prepayment-form-daysmax_amount'}
              wrapWithTextAfter={t('days')}
              justifyCenter={false}
              onlyInteger={true}
              wraping={false}
              minValueForNumber={0}
              name={'days'}
              size={size}
              label={t('BBO_2884_prepayment_days')}
            />

            <ButtonAdd addPrepayment={addPrepayment} />
          </Flex>
          {prepayment &&
            prepayment.map((p, i, pre) => {
              return (
                <>
                  <Flex
                    justifyBetween={true}
                    alignCenter={true}
                    style={{ marginTop: i === 0 ? '10px' : '0px' }}
                  >
                    <Desktop>
                      <div>{p.percent} %</div>
                      <div>
                        {p.days}{' '}
                        {t(
                          Number(p.days) === 1
                            ? t('days_count_day')
                            : t('days'),
                        )}
                      </div>
                    </Desktop>
                    <Mobile>
                      <div>
                        <div>
                          {t('BBO_1494_percent')}: <b>{p.percent} %</b>
                        </div>
                        <div>
                          {t('BBO_2884_prepayment_days')}:{' '}
                          <b>
                            {p.days}{' '}
                            {t(
                              Number(p.days) === 1
                                ? t('days_count_day')
                                : t('days'),
                            )}
                          </b>
                        </div>
                      </div>
                    </Mobile>
                    <div style={{ marginRight: '-8px' }}>
                      <IconButton
                        data-cy={'price-prepayment-form-edit-button'}
                        style={{ marginLeft: i === 0 ? '37px' : '0px' }}
                        onClick={editPrepayment(i)}
                      >
                        <FiEdit2 size={'16px'} />
                      </IconButton>
                      {i !== 0 && (
                        <IconButton
                          data-cy={'price-prepayment-form-delete-button'}
                          onClick={removePrepayment(i)}
                        >
                          <FiTrash size={'16px'} style={{ color: 'red' }} />
                        </IconButton>
                      )}
                    </div>
                  </Flex>
                  {i < pre.length - 1 && <Divider style={{ width: '100%' }} />}
                </>
              )
            })}
        </Flex>
      </Flex>
      <Mobile>
        <Divider style={{ marginTop: '15px' }} />
        <ButtonsWrapper size={size} style={{ margin: '0', marginTop: '1em' }}>
          <SubmitButton
            size={size}
            type="button"
            onClick={submitForm}
            style={{ width: '100%' }}
            className={'settings-button-submit'}
          >
            <FiSave />
            <Trans i18nKey={'save'} />
          </SubmitButton>
        </ButtonsWrapper>
      </Mobile>
    </Flex>
  )
}

function cannotAddPrepayment(percent, days) {
  return (
    percent === '' ||
    percent == null ||
    days === '' ||
    days == null ||
    isNaN(percent) ||
    isNaN(days)
  )
}

const ButtonAdd = formValues<any>({ days: 'days', percent: 'percent' })(
  ({ percent, days, addPrepayment }) => {
    const isDesktop = is.desktop()
    const disabled = cannotAddPrepayment(percent, days)

    const { t } = useTranslation()

    return (
      <>
        {isDesktop && (
          <AddButton
            data-cy={'price-prepayment-form-add-button'}
            onClick={disabled ? undefined : addPrepayment(percent, days)}
            disabled={disabled}
            isDisabled={disabled}
            style={{ marginBottom: '8px', marginLeft: '25px' }}
          >
            <FiPlus />
          </AddButton>
        )}
        {!isDesktop && (
          <Button
            data-cy={'price-prepayment-form-add-button'}
            onClick={disabled ? undefined : addPrepayment(percent, days)}
            disabled={disabled}
            style={{ fontSize: '14px', marginTop: '20px' }}
            primary={true}
          >
            {t('BBO_3089_add')}
          </Button>
        )}
      </>
    )
  },
)

export default reduxForm<any>({
  destroyOnUnmount: true,
  enableReinitialize: true,
  form: 'prepayment',
  onSubmit: (values, dispatch) =>
    dispatch({ type: PaymentDictionaryActions.SavePrepayment, values }),
})(Prepayment as any) as any
